import {Box, Divider, HStack, List, Menu, Pressable, Text} from 'native-base';
import React from 'react';
import {t} from 'react-native-tailwindcss';

export type Property = {
  label: string | JSX.Element;
  value?: string | null | false | JSX.Element;
  menu?: {
    options: Record<string, string>;
    onSelected: (newKey: string) => void;
  };
  onPress?: () => void;
};
export type Properties = Array<Property>;

type Props = {
  properties: Properties;
  showEndDivider?: boolean;
};

interface PropertyListItemProps {
  p: Property;
  showDivider: boolean;
  onPress?: () => void;
}

const PropertyListItem = React.forwardRef<any, PropertyListItemProps>(
  ({p, showDivider, onPress}, ref) => (
    <Box style={[t.mL5]}>
      <Pressable onPress={onPress} ref={ref}>
        <HStack justifyContent="space-between" alignItems="center" style={[t.mR5, t.h12]}>
          <Box style={t.flex1}>
            {typeof p.label === 'string' ? <Text>{p.label}</Text> : p.label}
          </Box>
          {typeof p.value === 'string' ? <Text style={[t.textRight]}>{p.value}</Text> : p.value}
        </HStack>
      </Pressable>
      {showDivider && <Divider bgColor={'gray.200'} />}
    </Box>
  )
);

export const PropertyList: React.FC<Props> = ({properties, showEndDivider}) => (
  <List style={{paddingTop: 0, paddingBottom: 0}} borderColor="transparent">
    {properties
      .filter((prop) => prop.value)
      .map((p, i, {length}) => {
        const {menu, value} = p;
        if (menu && typeof value === 'string') {
          const {options, onSelected} = menu;
          return (
            <Menu
              key={i}
              shouldOverlapWithTrigger
              placement="top right"
              offset={-100}
              trigger={(triggerProps) => {
                return (
                  <PropertyListItem
                    p={p}
                    showDivider={length - 1 !== i || !!showEndDivider}
                    onPress={triggerProps.onPress}
                    ref={triggerProps.ref}
                  />
                );
              }}>
              {Object.entries(options).map(([key, optionValue]) => {
                const isSelected = key === options[value];
                return (
                  <Menu.Item
                    key={key}
                    isPressed={isSelected}
                    onPress={() => {
                      if (isSelected) return;
                      onSelected(key);
                    }}>
                    {optionValue}
                  </Menu.Item>
                );
              })}
            </Menu>
          );
        }
        return (
          <PropertyListItem
            key={i}
            p={p}
            showDivider={length - 1 !== i || !!showEndDivider}
            onPress={p.onPress}
          />
        );
      })}
  </List>
);

export const PropertyCardList: React.FC<Props> = ({properties, showEndDivider}) => (
  <>
    {properties
      .filter((prop) => prop.value)
      .map((p, i, {length}) => {
        return (
          <Box key={i}>
            <Box style={[t.flexCol, {alignItems: 'flex-start'}, t.mY2, t.mX2]}>
              <Text style={[t.textSm, t.textGray600, {marginBottom: -2}]}>{p.label}</Text>
              <Text isTruncated>{p.value}</Text>
            </Box>
            {(length - 1 !== i || showEndDivider) && <Divider bgColor={'gray.200'} />}
          </Box>
        );
      })}
  </>
);
